import type { MailContentProps, MailMetadata } from "../../lib/types";
import { MailSignature } from "../mail/mail-signature";

function ProjetDemarcheRSE({ variablesData }: MailContentProps) {
  return (
    <div className="space-y-2">
      <p className="pb-4">
        Bonjour {variablesData.genre_masc_abrege}{" "}
        {variablesData.responsable_grand_est_precedent_nom},
      </p>
      <p>
        Au cours de la session de formation inter-entreprises que j'ai suivie le
        mois dernier, j'ai été sensibilisé à la mise en place d'une stratégie de
        développement durable. Certains intervenants ont relaté leurs
        expériences dans ce domaine.
      </p>
      <p>
        Ce fut fort enrichissant et cela m'a permis d'identifier tous les
        bénéfices que nous pourrions tirer dans notre entreprise, d'une telle
        démarche : principe de Responsabilité, d'Impact et d'Autonomie, principe
        de performance globale…
      </p>
      <p>
        Je pense qu'il serait intéressant que nous puissions initier ce type
        d'approche au sein de notre entreprise.{" "}
        {variablesData.demos_directeur_societe} propose une formation « La
        responsabilité Sociétale des Entreprises (RSE) : définir une stratégie
        gagnante» organisée autour de 4 modules, d'une durée de 2 jours, que je
        souhaiterais suivre. Cet investissement faciliterait l'accompagnement de
        la mise en place d'une stratégie RSE. Cette démarche permettrait à notre
        Société de conduire certains changements :
      </p>
      <ul className="list-disc pl-12">
        <li>
          le passage d'une gestion administrative à une gestion de la relation
          de service
        </li>
        <li>le développement d'une culture de résultats</li>
        <li>une exigence accrue de performance.</li>
      </ul>
      <p>Je joins en annexe le programme de la formation.</p>
      <p>Sincères salutations,</p>
      <MailSignature
        emetteurLogo={ProjetDemarcheRSE.metadata.emetteurLogo}
        emetteur={ProjetDemarcheRSE.metadata.emetteur}
        emetteurPoste={ProjetDemarcheRSE.metadata.emetteurPoste}
        emetteurEntreprise={ProjetDemarcheRSE.metadata.emetteurEntreprise}
      />
    </div>
  );
}

ProjetDemarcheRSE.metadata = {
  titre: "Projet démarche RSE (Responsabilité Sociétale des Entreprises)",
  cleMail: "projet_demarche_rse",
  messageTransfert: false,
  emetteur: "Claude LEBLANC",
  emetteurPoste: "Responsable Production",
  emetteurEntreprise: "SYTEL Grand Est",
  emetteurLogo: "/logos/sytel_grand_est.png",
  dateRelative: -7,
  piecesJointes: ["catalogue-demos-formation-rse"],
} as MailMetadata;

export default ProjetDemarcheRSE;
